import { render, staticRenderFns } from "./UdeContactForm.vue?vue&type=template&id=7466734a&scoped=true"
import script from "./UdeContactForm.vue?vue&type=script&lang=js"
export * from "./UdeContactForm.vue?vue&type=script&lang=js"
import style0 from "./UdeContactForm.vue?vue&type=style&index=0&id=7466734a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7466734a",
  null
  
)

export default component.exports